import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg viewBox="0 0 14 91" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...this.props}><path d="M3.2 0L0 3.3v11.3l7 6.7 7-6.7V0M3.2 69.1L0 72.4v11.3l7 6.7 7-6.7V69.1M6 27h2v36H6z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/panel-segment.inline.svg